import React, { useState, useEffect } from 'react';
import { AnimatePresence } from "framer-motion";
import ProductCard from "../ProductCard";
import LoaderAnimation from "../../lib/loaderAnimation";

export default function FormationFilterTab ({products, category}){

    const [filterData, setFilterData] = useState(products);
    // const [search, setSearch] = useState("");
    // const [filter, setFilter] = useState("");
    const [activeCategory, setActiveCategory] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if(products?.length > 0){
            setFilterData(products);
            setLoading(false);
        }
    }, [products]);


    /*const handleSearch = (e) => {
        setSearch(e.target.value);
        if (e.target.value === "") {
            setFilterData(products);
        } else {
            const filtered = products?.filter((product) =>
                    product.titre.toLowerCase().includes(search.toLowerCase())
            );
            setFilterData(filtered);
        }
    };*/

    const handleFilter = (selectedCategory) => {
        setActiveCategory(selectedCategory);

        if (selectedCategory === null) {
            setFilterData(products);
        } else {
            const filtered = products?.filter(product =>
                    product.categorie.some(cat => cat.titre === selectedCategory)
            );
            setFilterData(filtered);
        }
    };

    return(
        <>
            {/*<div className="flex justify-center items-center mt-4">
                <input
                        type="text"
                        placeholder="Rechercher une formation"
                        onChange={(e) => handleSearch(e)}
                        name="search"
                        className="border-2 border-gray-300 p-2 rounded-md max-w-xs w-full"
                />
            </div>*/}
            <div className="default-tabs tabs-box">
                {category && category.length > 0 ? (
                        <ul className="tab-buttons justify-content-center">
                            <li
                                    key="tab-all"
                                    className={`tab-btn ${activeCategory === null ? 'active-btn' : ''}`}
                                    onClick={() => handleFilter(null)}
                            >
                                Toutes les formations
                            </li>
                            {category.map((cat) => (
                                    <li
                                            key={`tab-${cat.id}`}
                                            className={`tab-btn ${activeCategory === cat.titre ? 'active-btn' : ''}`}
                                            onClick={() => handleFilter(cat.titre)}
                                    >
                                        {cat.titre}
                                    </li>
                            ))}
                        </ul>
                ) : (
                        ''
                )}

                <div className="tabs-content wow fadeInUp animated">
                    <div className="tab active-tab">
                        <div className="row">
                            <div className="content-side col-lg-12 col-md-12 col-sm-12 justify-content-between">
                                <div className="blog-grid">
                                    <div className="row col-12">
                                        {loading ?
                                            <LoaderAnimation />
                                            :
                                            filterData?.map((product) => (
                                                <AnimatePresence key={product.id}>
                                                    <ProductCard product={product} colLg="4"/>
                                                </AnimatePresence>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

